<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <div class="w-full px-4">
    <Input
      v-model="form.processor_name"
      solo
      label="Processor Name"
      class="w-full mb-3 border-bottom"
      name="Processor Name"
    />
    <Input
      v-model="form.reference_id"
      solo
      label="Reference #"
      class="w-full mb-3 border-bottom"
      name="Reference #"
    />
  </div>
</template>

<script lang="ts" setup>
import Input from "@/components/Input.vue";

defineProps({
  form: { type: Object, default: null }
});
</script>
